import React from 'react'

export default class Rules extends React.Component {
  componentDidMount () {
    const { history } = this.props
    history.push('postersetting/birthdayposter')
  }

  render () {
    return (
      <div />
    )
  }
}